import { createStore } from 'vuex'
import mapv2 from './modules/mapv2'
import getters from './getters'

export default createStore({
  state: {
  	guideTheme: {
  		color: '#9D8356',
  		title: '语音讲解'
  	}
  },
  modules: {
    mapv2
  },
  getters,
  strict: false
})
